// Translations
import landing from '../views/landing/translations/tr'

// Translation: Terms of service (Turkish)
export default Object.freeze({
	name: 'Hizmet şartları',
	views: { landing }
})
